<div class="page-auth">
    <div class="page-auth__inner">
        <a class="page-auth__logo"
            routerLink="/{{ appRoute.LOGIN }}">
            <img [src]="'/assets/' + environment.fullLogoPath || environment.logoPath"
                [alt]="environment.projectName + ' Logo'"
                width="100%" />
        </a>

        <ng-container *ngIf="activatedSection === loginPageSections.Login">
            <div class="page-auth__contextual-messages"
                *ngIf="contextualMessage || videoMessage">
                <div *ngIf="contextualMessage?.type === 'success'"
                    class="sl-status-bar sl-success"
                    role="status">
                    <mat-icon>check_circle</mat-icon> {{ contextualMessage.message }}
                </div>

                <div *ngIf="videoMessage"
                    class="sl-status-bar sl-warning"
                    role="status">
                    <mat-icon>warning</mat-icon> Please login to download the video
                </div>

                <div *ngIf="contextualMessage?.type === 'error'"
                    class="sl-status-bar sl-error"
                    role="status">
                    <mat-icon>not_interested</mat-icon> {{ contextualMessage.message }}
                </div>
            </div>

            <form class="page-auth__form"
                [formGroup]="loginFormGroup"
                (ngSubmit)="handleLogin()">
                <mat-form-field class="sl-form-field"
                    [class.loading]="loading">
                    <input matInput
                        type="text"
                        placeholder="Email Address"
                        [formControlName]="'email'"
                        autocapitalize="off"
                        required>
                    <mat-error *ngIf="loginFormGroup.controls['email'].errors?.required">
                        This Email Address is required
                    </mat-error>
                    <mat-error *ngIf="loginFormGroup.controls['email'].errors?.email">
                        This Email Address format is invalid
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="sl-form-field"
                    [class.loading]="loading">
                    <input matInput
                        type="password"
                        placeholder="Password"
                        [formControlName]="'password'"
                        required>
                    <mat-error *ngIf="loginFormGroup.controls['password'].errors?.required">
                        This Password is required
                    </mat-error>
                </mat-form-field>

                <div class="page-auth__form__submit-button-wrapper"
                    [class.loading]="loading">
                    <button [buttonType]="'secondary'"
                        type="submit"
                        value="Submit"
                        [disabled]="loading || (contextualMessage && contextualMessage.type==='success')">Login</button>
                </div>

                <sl-loader [light]="true"
                    *ngIf="loading"></sl-loader>
            </form>

            <p class="page-auth__forgot-password">Forgot Password?&nbsp;<a class="forgot-password-link"
                    routerLink="/{{ appRoute.FORGOT_PASSWORD }}">Click Here</a></p>
        </ng-container>

        <ng-container *ngIf="activatedSection === loginPageSections.ForgotPassword">
            <h2 class="heading-dark-bg"
                *ngIf="!errorMessage">Enter your email to reset your password.</h2>

            <div class="page-auth__contextual-messages">
                <div *ngIf="contextualMessage?.type === 'success'"
                    class="sl-status-bar sl-success"
                    role="status">
                    <mat-icon>check_circle</mat-icon> {{ contextualMessage.message }}
                </div>

                <div *ngIf="contextualMessage?.type === 'error'"
                    class="sl-status-bar sl-error"
                    role="status">
                    <mat-icon>not_interested</mat-icon> {{ contextualMessage.message }}
                </div>
            </div>

            <form class="page-auth__form"
                [formGroup]="forgotPasswordFormGroup"
                (ngSubmit)="handleForgotPassword()"
                *ngIf="!contextualMessage || contextualMessage.type !== 'success'">
                <mat-form-field class="sl-form-field"
                    [class.loading]="loading">
                    <input matInput
                        placeholder="Email Address"
                        [formControlName]="'email'"
                        #email
                        type="email"
                        autocapitalize="off"
                        required>
                    <mat-error *ngIf="forgotPasswordFormGroup.controls['email'].errors?.required">
                        This Email Address is required
                    </mat-error>
                    <mat-error *ngIf="forgotPasswordFormGroup.controls['email'].errors?.email">
                        This Email Address format is invalid
                    </mat-error>
                </mat-form-field>

                <div class="page-auth__form__submit-button-wrapper"
                    [class.loading]="loading">
                    <button [buttonType]="'secondary'"
                        type="submit"
                        value="Submit"
                        [disabled]="loading">{{'Reset Password' | translate}}</button>
                </div>

                <sl-loader [light]="true"
                    *ngIf="loading"></sl-loader>
            </form>
        </ng-container>

        <ng-container *ngIf="activatedSection === loginPageSections.ForceResetEmailSent">
            <div *ngIf="contextualMessage?.type === 'success'"
                class="sl-status-bar sl-success"
                role="status">
                <mat-icon>check_circle</mat-icon> {{ contextualMessage.message }}
            </div>

            <div *ngIf="contextualMessage?.type === 'error'"
                class="sl-status-bar sl-error"
                role="status">
                <mat-icon>not_interested</mat-icon> {{ contextualMessage.message }}
            </div>
        </ng-container>

        <ng-container *ngIf="activatedSection === loginPageSections.CreateNewPassword">
            <h2 class="heading-dark-bg">Create New Password</h2>
            <change-password (changePasswordSuccessful)="passwordChangedSuccessfully($event)"></change-password>
        </ng-container>
    </div>

    <ng-container *ngIf="supportButtonUrl">
        <sl-support-button [supportUrl]="supportButtonUrl"></sl-support-button>
    </ng-container>

</div>
